import React, { useEffect, useState } from "react";
import WorkflowUpdatedPhaseSettings from './SettingsComponents/WorkflowUpdatedPhaseSettings';
import WorkflowSettings from './SettingsComponents/WorkflowSettings';

function WorkflowsMenuSectionRoleAssingnment(props) {
  const [settingsWorkflowId, setSettingsWorkflowId] = useState(1);
  const [settingsWorkflowPhasesList, setSettingsWorkflowPhasesList] = useState([]);

  useEffect(() => {
    if (props.workflowPhases && settingsWorkflowId) {
      const filteredPhases = props.workflowPhases.filter(
        (phase) => Number(phase.WorkflowsMaster) === Number(settingsWorkflowId)
      );
      setSettingsWorkflowPhasesList(filteredPhases);
    }
  }, [props.workflowPhases, settingsWorkflowId]);

  const handleSettingsWorkflowChange = (workflowId) => {
    setSettingsWorkflowId(workflowId);
    
    const filteredPhases =
      props.workflowPhases &&
      props.workflowPhases.filter(
        (phase) => Number(phase.WorkflowsMaster) === Number(workflowId)
      );
  
    setSettingsWorkflowPhasesList(filteredPhases || []);
  };

  const workflowDropdown = (
    <div className="d-flex align-items-center">
      <label className="mb-0 mr-2" style={{ whiteSpace: "nowrap" }}>
        <b>Workflow : </b>
      </label>
      <select
        onChange={(e) => handleSettingsWorkflowChange(e.target.value)}
        value={settingsWorkflowId}
        className="form-control"
        style={{ width: "250px" }}
      >
        <option value="" disabled>--Select Workflow--</option>
        {props.workflowMainCategory &&
          props.workflowMainCategory.map((wf) => (
            <option key={wf.id} value={wf.id}>
              {wf.name}
            </option>
          ))}
      </select>
    </div>
  );

  return ( 
    <> 
      {/* <div className="d-flex align-items-center ml-2 mt-3">
        <label className="mb-0" style={{ minWidth: "100px" }}>
          Workflow : 
        </label>

        <select
          onChange={(e) => handleSettingsWorkflowChange(e.target.value)}
          value={settingsWorkflowId}
          className="form-control"
          style={{ width: "250px" }}
        >
          <option value="" disabled>--Select Workflow--</option>
          {props.workflowMainCategory &&
            props.workflowMainCategory.map((wf) => (
              <option key={wf.id} value={wf.id}>
                {wf.name}
              </option>
            ))}
        </select>
      </div> */}
      
      {Number(settingsWorkflowId) === 10 ? (
        <WorkflowUpdatedPhaseSettings
          settingsWorkflowId={settingsWorkflowId}
          workflowPhases={settingsWorkflowPhasesList} 
          workflowMasterPhases={props.workflowMasterPhases}
          workflowMainCategory={props.workflowMainCategory}
          token={props.token}
          isPreviewMode={true} 
          selectedTask={props.selectedTask} 
          flag={props.flag}
          handleBackButtonToWorkflow={props.handleBackButtonToWorkflow}
          selectedStoreData={props.selectedStoreData}
          workflowDropdown={workflowDropdown}
        />
      ) : (
        <WorkflowSettings 
          settingsWorkflowId={settingsWorkflowId}
          workflowPhases={settingsWorkflowPhasesList}
          workflowMainCategory={props.workflowMainCategory}
          selectedTask={props.selectedTask}
          flag={props.flag}
          isPreviewMode={true}  
          handleBackButtonToWorkflow={props.handleBackButtonToWorkflow}
          selectedStoreData={props.selectedStoreData}
          workflowDropdown={workflowDropdown}
        />
      )}  
    </>
  )
}

export default WorkflowsMenuSectionRoleAssingnment;